import Alpine from "alpinejs";
import { validatorController } from "./validator-controller";
import "./register-validators";

document.addEventListener("alpine:init", () => {
    // Register the Alpine directive
    Alpine.directive("validator", (el, { expression }, { evaluateLater, effect, cleanup, scope }) => {
        if (el.tagName !== "FORM") {
            // eslint-disable-next-line no-console
            console.warn("x-validator directive should only be used on form elements", el);
            return;
        }

        // Use evaluateLater and effect to ensure Alpine scope is ready
        const getScope = evaluateLater(expression || "{}");

        effect(() => {
            getScope(resolvedScope => {
                // Pass the resolved scope (or default if expression is empty)
                // Using Alpine.$data might be unreliable here, direct scope is better
                const formScope = scope || resolvedScope;
                validatorController.initializeForm(el, formScope);
            });
        });

        // Cleanup when the element is removed
        cleanup(() => {
            validatorController.destroyForm(el);
        });
    });
});

// Export controller or other elements if needed for external use
export { validatorController };
